// src/pinball/tables/JungleQuestTable.ts - Jungle Quest theme configuration

import { TableThemeConfig } from '../types';

export const JungleQuestTable: TableThemeConfig = {
  id: 'jungle-quest',
  name: 'Jungle Quest',
  description: 'Explore ancient temples and dodge jungle creatures for treasure!',
  previewImage: '',
  width: 400,
  height: 800,

  elements: [
    // Temple bumpers
    {
      id: 'temple_stone_1',
      type: 'pop_bumper',
      position: { x: 160, y: 210 },
      properties: { radius: 20, restitution: 1.2, activeImpulse: 280, pointValue: 125, color: '#cc8844' },
    },
    {
      id: 'temple_stone_2',
      type: 'pop_bumper',
      position: { x: 240, y: 190 },
      properties: { radius: 20, restitution: 1.2, activeImpulse: 280, pointValue: 125, color: '#cc8844' },
    },
    {
      id: 'temple_stone_3',
      type: 'pop_bumper',
      position: { x: 200, y: 270 },
      properties: { radius: 22, restitution: 1.2, activeImpulse: 280, pointValue: 125, color: '#aa6633' },
    },
    // Vine bumpers
    {
      id: 'vine_bumper_1',
      type: 'bumper',
      position: { x: 90, y: 360 },
      properties: { radius: 16, restitution: 0.9, pointValue: 60, color: '#228822' },
    },
    {
      id: 'vine_bumper_2',
      type: 'bumper',
      position: { x: 310, y: 360 },
      properties: { radius: 16, restitution: 0.9, pointValue: 60, color: '#228822' },
    },
    // Slingshots (jungle traps)
    {
      id: 'trap_left',
      type: 'slingshot',
      position: { x: 80, y: 620 },
      properties: { width: 40, height: 40, restitution: 0.8, pointValue: 10, color: '#44aa22' },
    },
    {
      id: 'trap_right',
      type: 'slingshot',
      position: { x: 280, y: 620 },
      properties: { width: -40, height: 40, restitution: 0.8, pointValue: 10, color: '#44aa22' },
    },
    // Idol drop targets
    {
      id: 'idol_1',
      type: 'drop_target',
      position: { x: 120, y: 440 },
      properties: { width: 25, pointValue: 600, group: 'idols', groupIndex: 0, color: '#ffcc00' },
    },
    {
      id: 'idol_2',
      type: 'drop_target',
      position: { x: 160, y: 440 },
      properties: { width: 25, pointValue: 600, group: 'idols', groupIndex: 1, color: '#ffcc00' },
    },
    {
      id: 'idol_3',
      type: 'drop_target',
      position: { x: 200, y: 440 },
      properties: { width: 25, pointValue: 600, group: 'idols', groupIndex: 2, color: '#ffcc00' },
    },
    {
      id: 'idol_4',
      type: 'drop_target',
      position: { x: 240, y: 440 },
      properties: { width: 25, pointValue: 600, group: 'idols', groupIndex: 3, color: '#ffcc00' },
    },
    {
      id: 'idol_5',
      type: 'drop_target',
      position: { x: 280, y: 440 },
      properties: { width: 25, pointValue: 600, group: 'idols', groupIndex: 4, color: '#ffcc00' },
    },
    // Treasure target
    {
      id: 'treasure_target',
      type: 'target',
      position: { x: 200, y: 140 },
      properties: { width: 30, pointValue: 400, color: '#ffdd00' },
    },
    // Waterfall spinner
    {
      id: 'waterfall_spinner',
      type: 'spinner',
      position: { x: 160, y: 330 },
      properties: { width: 30, pointValue: 20, color: '#4488ff' },
    },
    // Temple ramps
    {
      id: 'temple_ramp',
      type: 'ramp',
      position: { x: 120, y: 520 },
      properties: {
        pointValue: 6000,
        path: [{ x: 120, y: 520 }, { x: 90, y: 300 }, { x: 150, y: 140 }],
        color: '#886633',
      },
    },
    {
      id: 'waterfall_ramp',
      type: 'ramp',
      position: { x: 280, y: 520 },
      properties: {
        pointValue: 6000,
        path: [{ x: 280, y: 520 }, { x: 310, y: 300 }, { x: 250, y: 140 }],
        color: '#4488cc',
      },
    },
    // Jungle paths (lanes)
    {
      id: 'path_left',
      type: 'lane',
      position: { x: 60, y: 100 },
      properties: { pointValue: 1200, path: [{ x: 60, y: 100 }, { x: 60, y: 200 }], color: '#88cc44' },
    },
    {
      id: 'path_center',
      type: 'lane',
      position: { x: 200, y: 75 },
      properties: { pointValue: 1200, path: [{ x: 180, y: 75 }, { x: 220, y: 75 }], color: '#88cc44' },
    },
    {
      id: 'path_right',
      type: 'lane',
      position: { x: 340, y: 100 },
      properties: { pointValue: 1200, path: [{ x: 340, y: 100 }, { x: 340, y: 200 }], color: '#88cc44' },
    },
    // Orbit (jungle loop)
    {
      id: 'jungle_orbit',
      type: 'orbit',
      position: { x: 200, y: 110 },
      properties: {
        pointValue: 3500,
        path: [{ x: 60, y: 300 }, { x: 50, y: 100 }, { x: 200, y: 55 }, { x: 350, y: 100 }, { x: 340, y: 300 }],
        color: '#44cc44',
      },
    },
  ],

  flippers: [
    {
      id: 'flipper_left',
      side: 'left',
      pivot: { x: 130, y: 720 },
      length: 60,
      restAngle: Math.PI / 6,
      activeAngle: -Math.PI / 6,
      activationTime: 50,
      returnTime: 80,
    },
    {
      id: 'flipper_right',
      side: 'right',
      pivot: { x: 270, y: 720 },
      length: 60,
      restAngle: Math.PI - Math.PI / 6,
      activeAngle: Math.PI + Math.PI / 6,
      activationTime: 50,
      returnTime: 80,
    },
  ],

  plunger: {
    position: { x: 375, y: 750 },
    laneWidth: 30,
    laneHeight: 100,
    maxLaunchSpeed: 3000,
    chargeTime: 1500,
  },

  drain: {
    position: { x: 200, y: 780 },
    width: 100,
  },

  outlanes: [
    { id: 'outlane_left', side: 'left', path: [{ x: 30, y: 650 }, { x: 30, y: 780 }] },
    { id: 'outlane_right', side: 'right', path: [{ x: 370, y: 650 }, { x: 370, y: 780 }] },
  ],

  inlanes: [
    { id: 'inlane_left', side: 'left', path: [{ x: 80, y: 650 }, { x: 100, y: 700 }] },
    { id: 'inlane_right', side: 'right', path: [{ x: 320, y: 650 }, { x: 300, y: 700 }] },
  ],

  walls: [
    { id: 'wall_left', start: { x: 20, y: 20 }, end: { x: 20, y: 780 }, restitution: 0.5 },
    { id: 'wall_top', start: { x: 20, y: 20 }, end: { x: 395, y: 20 }, restitution: 0.5 },
    { id: 'wall_right', start: { x: 395, y: 20 }, end: { x: 395, y: 780 }, restitution: 0.5 },
    { id: 'wall_plunger_left', start: { x: 350, y: 300 }, end: { x: 350, y: 780 }, restitution: 0.3 },
    { id: 'wall_guide_left', start: { x: 20, y: 780 }, end: { x: 130, y: 740 }, restitution: 0.4 },
    { id: 'wall_guide_right', start: { x: 350, y: 780 }, end: { x: 270, y: 740 }, restitution: 0.4 },
    { id: 'wall_arch_1', start: { x: 393, y: 60 }, end: { x: 390, y: 45 }, restitution: 0.7 },
    { id: 'wall_arch_2', start: { x: 390, y: 45 }, end: { x: 383, y: 32 }, restitution: 0.7 },
    { id: 'wall_arch_3', start: { x: 383, y: 32 }, end: { x: 372, y: 24 }, restitution: 0.7 },
    { id: 'wall_arch_4', start: { x: 372, y: 24 }, end: { x: 358, y: 21 }, restitution: 0.7 },
    { id: 'wall_arch_5', start: { x: 358, y: 21 }, end: { x: 340, y: 25 }, restitution: 0.7 },
    { id: 'wall_arch_6', start: { x: 340, y: 25 }, end: { x: 325, y: 35 }, restitution: 0.7 },
  ],

  scoring: {
    comboWindow: 5000,
    comboMultipliers: [1, 1.5, 2, 2.5, 3, 3.5, 4],
    endOfBallBonusBase: 6000,
    jackpotValue: 60000,
  },

  jackpotCondition: {
    type: 'all_ramps',
    requiredElements: ['temple_ramp', 'waterfall_ramp', 'jungle_orbit'],
    description: 'Complete both temple paths and the jungle orbit for JACKPOT!',
  },

  multiballCondition: {
    type: 'target_bank',
    requiredElements: ['idol_1', 'idol_2', 'idol_3', 'idol_4', 'idol_5'],
    ballCount: 3,
    description: 'Collect all golden idols for MULTIBALL!',
  },

  theme: {
    backgroundColor: '#0a1a0a',
    playfieldColor: '#1a3a1a',
    wallColor: '#4a8a2a',
    ballColor: '#dddddd',
    flipperColor: '#cc8833',
    fontFamily: '"Courier New", monospace',
    darkModeOverrides: {
      backgroundColor: '#050d05',
      playfieldColor: '#0d1f0d',
    },
  },
};
